import React from "react";
import { AbsoluteFill } from "../AbsoluteFill";
import { HeartIcon } from "../shared/Icons";

export const YellowHeart = () => {
  return (
    <AbsoluteFill
      style={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <HeartIcon size={48} color="#ecc94b" />
    </AbsoluteFill>
  );
};
